import AccountingNoteDialog from './AccountingNoteDialog';

export default AccountingNoteDialog;
